import { cn } from "@omni/utils/styles";

import { Overlay } from "@/components/General/Overlay/overlay";
import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";
import { ConditionalWrapper } from "@/utils/helpers";

type Props = {
    className?: string;
};

export const Menu = ({ className }: Props) => {
    const { isActive, menuElement, onCloseMenu, withOverlay } =
        useHeaderButtonContext();

    if (!menuElement) return null;

    return (
        <ConditionalWrapper
            condition={withOverlay}
            wrapper={(children) => {
                return (
                    <Overlay
                        open={isActive}
                        overlayHeader={true}
                        scrollLock={true}
                        onClose={onCloseMenu}
                    >
                        <Overlay.Content>{children}</Overlay.Content>
                    </Overlay>
                );
            }}
        >
            <div
                className={cn(
                    "tw:z-10 tw:hidden tw:absolute tw:top-0 tw:right-0 tw:w-100 tw:max-w-dvw tw:h-full tw:pt-9 tw:px-4 tw:pb-4 tw:origin-top-right",
                    "tw:lg:-top-2 tw:lg:-right-4 tw:lg:h-fit",
                    {
                        "tw:block tw:animate-popover": isActive
                    },
                    className
                )}
            >
                {menuElement}
            </div>
        </ConditionalWrapper>
    );
};
